import React from "react";
//import axios from 'axios';
import AuthService from '../Services/auth.service';
import './Register.css';
class Register extends React.Component {

  constructor(){
    super();
    this.state = {
        cats : [],
    }
    this.signUp = this.signUp.bind(this);
}
signUp (){
    
    alert(AuthService.sendOTP())
}
  render() {
    return <div>

<div className="row  ">


  <div className="   p-5 center-space">
    <div className="text-center">
      <a className="" href="/#">  <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid mb-2 popup-img" />  </a>
      {/* <a className="" href="/#"> <img src="/assets/images/logo/logo-3.png" alt="" title="" className="img-fluid " /> </a><br/> */}
    </div>
        

    <div className="row-form  mt-3  num-left mb-2">
                        <h6  className="green-label ">Name</h6>
                        <input className="form-controls " type="text" placeholder="" id="name"  onChange={e => this.name = e.target.value}/>

                        </div> 
                        <div className="row-form  num-left  mb-2">
                        <h6  className="green-label ">Mobile</h6>
                        <input className="form-controls " type="text" placeholder="" id="mobile"  onChange={e => this.mobileNo = e.target.value} value={this.props.uMobile}/>

                        </div> 
                        <div className="row-form   num-left  mb-4">
                        <h6  className="green-label ">E-mail</h6>
                        <input className="form-controls " type="text" placeholder="" id="email"  onChange={e => this.email = e.target.value}/>

                        </div> 
                        <div className="text-center ">
                            <button type="button" className=" add-to-cart2 btnn " onClick={() => this.props.updateState(this.name,this.mobileNo,this.email)}>Send OTP</button><br/>
                            <button type="button" className="  btnn  btn-outline-green" onClick={() => this.props.handleCancel('false')}>Cancel</button></div>


</div>




</div>







    </div>
    }
}

export default Register;
